import axiosInstance from '../services/axiosInstance';
import { renderInvoiceESCPOS } from './escposReceiptRenderer';
import { sendToPrinter } from './transports/qzTransport';
import { ensurePrinterMode } from './utils/ensurePrinterMode';
import { renderPOBarcodeTSPL } from './poBarcodeLabelRenderer';

/**
 * Invoice printing (ESC/POS only)
 */
export async function printInvoice({
    invoice,
    org,
    onRequireModeConfirm,
}) {
    // 1️⃣ Resolve printer from backend
    const res = await axiosInstance.get('/api/printers/resolve/', {
        params: { usage_type: 'INVOICE' }
    });

    const printer = res.data;

    // 2️⃣ Ensure printer mode (ESC_POS)
    const canProceed = await ensurePrinterMode({
        printerId: printer.printer_id,
        requiredLanguage: printer.required_language,
        onRequireConfirm: onRequireModeConfirm,
    });

    if (!canProceed) return;
    console.log("printer proceed: ",canProceed);
    await new Promise(requestAnimationFrame);

    // 3️⃣ Render invoice (ESC/POS)
    const orgSettingsRaw = localStorage.getItem('organizationSettings');
    const orgSettings = orgSettingsRaw ? JSON.parse(orgSettingsRaw) : {};
    const printingCfg =
        orgSettings?.custom_json_settings?.printing || {};
    const branding = orgSettings?.custom_json_settings?.branding || {};
    const commands = renderInvoiceESCPOS(
        invoice,
        {
            organization_name: orgSettings.organization_name,
            address: orgSettings.department.address,
            contact_number: orgSettings.department.contact_phone,
            logo_escpos_base64: branding.logo_escpos_base64,
            org_logo_print: branding.show_in_invoice
        },
        printingCfg
    );

    // 4️⃣ Send to resolved printer
    console.log("Send to Printer: ", printer.name);
    await sendToPrinter(printer.name, commands);
}

export async function printPOBarcodes({
  items,
  onRequireModeConfirm,
}) {
  const res = await axiosInstance.get('/api/printers/resolve/', {
    params: { usage_type: 'LABEL' }
  });

  const printer = res.data;

  const canProceed = ensurePrinterMode({
    printerId: printer.printer_id,
    requiredLanguage: 'TSPL',
    onRequireConfirm: onRequireModeConfirm,
  });

  if (!canProceed) return;

  const orgSettings =
    JSON.parse(localStorage.getItem('organizationSettings') || '{}');

  const cfg = orgSettings?.custom_json_settings?.printing || {};

  const raw = renderPOBarcodeTSPL(items, cfg);
  await sendToPrinter(printer.name, raw);
}
